<div *ngIf="isPageReady" class="flex h-full flex-col">
  <div class="p-4">
    <!-- Headline numbers -->
    <div class="mb-4 flex items-center gap-6">
      <div class="flex items-center gap-2">
        <i class="pi pi-check-circle text-2xl" style="color: var(--p-green-500, #22c55e);"></i>
        <div>
          <div class="text-2xl font-semibold">{{ successCount }}</div>
          <div class="text-sm" style="color: var(--p-text-muted-color);">Succeeded</div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <i class="pi pi-times-circle text-2xl" style="color: var(--p-red-500, #ef4444);"></i>
        <div>
          <div class="text-2xl font-semibold">{{ failureCount }}</div>
          <div class="text-sm" style="color: var(--p-text-muted-color);">Failed</div>
        </div>
      </div>
    </div>

    <!-- Failure breakdown -->
    <ng-container *ngIf="failureCount > 0">
      <div class="qb-panel-title mb-2">Failure Details</div>
      <table class="qb-info-table w-full">
        <thead>
          <tr>
            <th class="label">Invoice #</th>
            <th class="label">Account</th>
            <th class="label">Step</th>
            <th class="label">Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of failures">
            <td class="value">{{ f.invoiceId }}</td>
            <td class="value">{{ f.accountName }}</td>
            <td class="value">{{ f.failedStep }}</td>
            <td class="value">{{ f.error }}</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3 text-sm" style="color: var(--p-text-muted-color);">
        Failed rows remain in the pending grid for retry. Idempotency guards ensure
        already-completed steps are skipped on the next attempt.
      </div>
    </ng-container>

    <ng-container *ngIf="failureCount === 0">
      <div class="text-sm" style="color: var(--p-text-muted-color);">
        All selected invoices processed successfully.
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="flex justify-end p-3" style="border-top: 1px solid var(--qb-card-border, #e5e7eb);">
    <button pButton type="button" class="p-button-raised" (click)="close()"><span>Close</span></button>
  </div>
</div>
